//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  Observable,
  from as _observableFrom,
  of as _observableOf,
  throwError as _observableThrow,
} from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';
import { UsertStore } from '../context/userStore';
import { GATEWAY_API_BASE_URL } from './mhsGatewayApiTokens';

@Injectable({
  providedIn: 'root',
})
export class MhsIdentityApiClient {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  private http = inject(HttpClient);
  private userStore = inject(UsertStore);
  private baseUrl = inject(GATEWAY_API_BASE_URL, { optional: true });
  /**
   * @param tenant_name (optional) name of tenant
   * @param subId (optional) subId of the user
   * @param modules (optional) modules of the user
   * @param tenants_access (optional) tenants of the user
   * @param body (optional)
   * @return OK
   */

  protected transformOptions(options: any): Promise<any> {
    options.headers = options.headers.append(
      'tenant-name',
      this.userStore.currentTenant()?.tenantName,
    );
    return Promise.resolve(options);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  nhfAccess_CreateUser(
    body: NhfAccessCreateRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<number> {
    let url_ = this.baseUrl + '/gateway/identity/nhfaccess/register';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfAccess_CreateUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfAccess_CreateUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        }),
      );
  }

  protected processNhfAccess_CreateUser(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  nhfAccess_ChangePassword(
    body: NhfAccessChangePasswordRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/identity/nhfaccess/change-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfAccess_ChangePassword(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfAccess_ChangePassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processNhfAccess_ChangePassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param isOrderByAsc (optional)
   * @return OK
   */
  nhfAccess_Search(
    pageIndex: number | undefined,
    pageSize: number | undefined,
    orderBy: string | undefined,
    isOrderByAsc: boolean | undefined,
    httpContext?: HttpContext,
  ): Observable<NhfAccessRowItemSearchResult> {
    let url_ = this.baseUrl + '/gateway/identity/nhfaccess/search?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
      url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy === null) throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
    else if (orderBy !== undefined) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (isOrderByAsc === null)
      throw new globalThis.Error("The parameter 'isOrderByAsc' cannot be null.");
    else if (isOrderByAsc !== undefined)
      url_ += 'IsOrderByAsc=' + encodeURIComponent('' + isOrderByAsc) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfAccess_Search(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfAccess_Search(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<NhfAccessRowItemSearchResult>;
            }
          } else
            return _observableThrow(response_) as any as Observable<NhfAccessRowItemSearchResult>;
        }),
      );
  }

  protected processNhfAccess_Search(
    response: HttpResponseBase,
  ): Observable<NhfAccessRowItemSearchResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NhfAccessRowItemSearchResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return OK
   */
  nhfAccess_GetPassword(
    id: number | undefined,
    body: string | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/identity/nhfaccess/get-password?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfAccess_GetPassword(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfAccess_GetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processNhfAccess_GetPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  nhfAccess_CreateOtp(
    body: NhfAccessOtpCreateRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<number> {
    let url_ = this.baseUrl + '/gateway/identity/nhfaccess/otp/register';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfAccess_CreateOtp(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfAccess_CreateOtp(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        }),
      );
  }

  protected processNhfAccess_CreateOtp(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  nhfAccess_UpdateOtp(
    body: NhfAccessOtpUpdateRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/identity/nhfaccess/otp/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfAccess_UpdateOtp(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfAccess_UpdateOtp(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processNhfAccess_UpdateOtp(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return OK
   */
  nhfAccess_GetOtpCode(
    id: number | undefined,
    body: string | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/identity/nhfaccess/otp/get-code?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfAccess_GetOtpCode(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfAccess_GetOtpCode(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processNhfAccess_GetOtpCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  nhfProfile_GetP1ReferralProfiles(httpContext?: HttpContext): Observable<P1Profile[]> {
    let url_ = this.baseUrl + '/gateway/identity/nhfprofile/p1/referral';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfProfile_GetP1ReferralProfiles(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfProfile_GetP1ReferralProfiles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<P1Profile[]>;
            }
          } else return _observableThrow(response_) as any as Observable<P1Profile[]>;
        }),
      );
  }

  protected processNhfProfile_GetP1ReferralProfiles(
    response: HttpResponseBase,
  ): Observable<P1Profile[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(P1Profile.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  nhfSettelmentsProfile_GetP1ReferralProfiles(
    httpContext?: HttpContext,
  ): Observable<SettlementProfile[]> {
    let url_ = this.baseUrl + '/gateway/identity/nhfsettlements/profiles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfSettelmentsProfile_GetP1ReferralProfiles(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfSettelmentsProfile_GetP1ReferralProfiles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SettlementProfile[]>;
            }
          } else return _observableThrow(response_) as any as Observable<SettlementProfile[]>;
        }),
      );
  }

  protected processNhfSettelmentsProfile_GetP1ReferralProfiles(
    response: HttpResponseBase,
  ): Observable<SettlementProfile[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(SettlementProfile.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param serviceProviderCode (optional)
   * @param oldPassword (optional)
   * @param newPassword (optional)
   * @return OK
   */
  nhfSettelmentsProfile_UpdatePassword(
    serviceProviderCode: string | undefined,
    oldPassword: string | undefined,
    newPassword: string | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/identity/nhfsettlements/update-password?';
    if (serviceProviderCode === null)
      throw new globalThis.Error("The parameter 'serviceProviderCode' cannot be null.");
    else if (serviceProviderCode !== undefined)
      url_ += 'serviceProviderCode=' + encodeURIComponent('' + serviceProviderCode) + '&';
    if (oldPassword === null)
      throw new globalThis.Error("The parameter 'oldPassword' cannot be null.");
    else if (oldPassword !== undefined)
      url_ += 'oldPassword=' + encodeURIComponent('' + oldPassword) + '&';
    if (newPassword === null)
      throw new globalThis.Error("The parameter 'newPassword' cannot be null.");
    else if (newPassword !== undefined)
      url_ += 'newPassword=' + encodeURIComponent('' + newPassword) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('put', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfSettelmentsProfile_UpdatePassword(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfSettelmentsProfile_UpdatePassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processNhfSettelmentsProfile_UpdatePassword(
    response: HttpResponseBase,
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  user_CreateUser(
    body: UserCreateRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<LoginUserDetails> {
    let url_ = this.baseUrl + '/gateway/identity/user/register';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_CreateUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_CreateUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LoginUserDetails>;
            }
          } else return _observableThrow(response_) as any as Observable<LoginUserDetails>;
        }),
      );
  }

  protected processUser_CreateUser(response: HttpResponseBase): Observable<LoginUserDetails> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LoginUserDetails.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  user_UpdateUser(
    body: UserUpdateRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<LoginUserDetails> {
    let url_ = this.baseUrl + '/gateway/identity/user/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_UpdateUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_UpdateUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LoginUserDetails>;
            }
          } else return _observableThrow(response_) as any as Observable<LoginUserDetails>;
        }),
      );
  }

  protected processUser_UpdateUser(response: HttpResponseBase): Observable<LoginUserDetails> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LoginUserDetails.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userId (optional)
   * @return OK
   */
  user_ResetPassword(userId: number | undefined, httpContext?: HttpContext): Observable<string> {
    let url_ = this.baseUrl + '/gateway/identity/user/password-reset?';
    if (userId === null) throw new globalThis.Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_ResetPassword(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_ResetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processUser_ResetPassword(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userId (optional)
   * @return OK
   */
  user_EnableUser(userId: number | undefined, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/gateway/identity/user/enable?';
    if (userId === null) throw new globalThis.Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('put', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_EnableUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_EnableUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUser_EnableUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userId (optional)
   * @return OK
   */
  user_DisableUser(userId: number | undefined, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/gateway/identity/user/disable?';
    if (userId === null) throw new globalThis.Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('put', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DisableUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DisableUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUser_DisableUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  user_GetUser(id: number, httpContext?: HttpContext): Observable<LoginIdetityUserDetails> {
    let url_ = this.baseUrl + '/gateway/identity/user/{id}';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LoginIdetityUserDetails>;
            }
          } else return _observableThrow(response_) as any as Observable<LoginIdetityUserDetails>;
        }),
      );
  }

  protected processUser_GetUser(response: HttpResponseBase): Observable<LoginIdetityUserDetails> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LoginIdetityUserDetails.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param phrase (optional)
   * @param lastName (optional)
   * @param isActive (optional)
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param isOrderByAsc (optional)
   * @return OK
   */
  user_Search(
    phrase: string | undefined,
    lastName: string | undefined,
    isActive: string | undefined,
    pageIndex: number | undefined,
    pageSize: number | undefined,
    orderBy: string | undefined,
    isOrderByAsc: boolean | undefined,
    httpContext?: HttpContext,
  ): Observable<UserHeaderRowItemSearchResult> {
    let url_ = this.baseUrl + '/gateway/identity/user/search?';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'Phrase=' + encodeURIComponent('' + phrase) + '&';
    if (lastName === null) throw new globalThis.Error("The parameter 'lastName' cannot be null.");
    else if (lastName !== undefined) url_ += 'LastName=' + encodeURIComponent('' + lastName) + '&';
    if (isActive === null) throw new globalThis.Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined) url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
      url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy === null) throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
    else if (orderBy !== undefined) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (isOrderByAsc === null)
      throw new globalThis.Error("The parameter 'isOrderByAsc' cannot be null.");
    else if (isOrderByAsc !== undefined)
      url_ += 'IsOrderByAsc=' + encodeURIComponent('' + isOrderByAsc) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_Search(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_Search(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserHeaderRowItemSearchResult>;
            }
          } else
            return _observableThrow(response_) as any as Observable<UserHeaderRowItemSearchResult>;
        }),
      );
  }

  protected processUser_Search(
    response: HttpResponseBase,
  ): Observable<UserHeaderRowItemSearchResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserHeaderRowItemSearchResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export enum IdentityTypes {
  PESEL = 'PESEL',
  ID_CARD = 'ID_CARD',
  PASSPORT = 'PASSPORT',
  DRIVER_ID = 'DRIVER_ID',
  RES_CARD = 'RES_CARD',
  ID_FOREGINER_DOC = 'ID_FOREGINER_DOC',
  OTHER = 'OTHER',
}

export class LoginIdetityUserDetails implements ILoginIdetityUserDetails {
  roles?: string[] | undefined;
  claims?: { [key: string]: string } | undefined;
  login?: string | undefined;
  unitIds?: number[] | undefined;
  roleName?: string | undefined;
  units?: UnitItem[] | undefined;
  id?: number;
  companyId?: number;
  ssoLogin?: string | undefined;
  subId?: number;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: string | undefined;
  roleId?: number;
  isActive?: boolean;
  timeStamp?: Date;

  constructor(data?: ILoginIdetityUserDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(item);
      }
      if (_data['claims']) {
        this.claims = {} as any;
        for (let key in _data['claims']) {
          if (_data['claims'].hasOwnProperty(key))
            (this.claims as any)![key] = _data['claims'][key];
        }
      }
      this.login = _data['login'];
      if (Array.isArray(_data['unitIds'])) {
        this.unitIds = [] as any;
        for (let item of _data['unitIds']) this.unitIds!.push(item);
      }
      this.roleName = _data['roleName'];
      if (Array.isArray(_data['units'])) {
        this.units = [] as any;
        for (let item of _data['units']) this.units!.push(UnitItem.fromJS(item));
      }
      this.id = _data['id'];
      this.companyId = _data['companyId'];
      this.ssoLogin = _data['ssoLogin'];
      this.subId = _data['subId'];
      this.firstName = _data['firstName'];
      this.secondName = _data['secondName'];
      this.lastName = _data['lastName'];
      this.identifierType = _data['identifierType'];
      this.identifierValue = _data['identifierValue'];
      this.email = _data['email'];
      this.phone = _data['phone'];
      this.title = _data['title'];
      this.licenceNumber = _data['licenceNumber'];
      this.specialisation = _data['specialisation'];
      this.defaultUnitId = _data['defaultUnitId'];
      this.roleId = _data['roleId'];
      this.isActive = _data['isActive'];
      this.timeStamp = _data['timeStamp']
        ? new Date(_data['timeStamp'].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): LoginIdetityUserDetails {
    data = typeof data === 'object' ? data : {};
    let result = new LoginIdetityUserDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item);
    }
    if (this.claims) {
      data['claims'] = {};
      for (let key in this.claims) {
        if (this.claims.hasOwnProperty(key))
          (data['claims'] as any)[key] = (this.claims as any)[key];
      }
    }
    data['login'] = this.login;
    if (Array.isArray(this.unitIds)) {
      data['unitIds'] = [];
      for (let item of this.unitIds) data['unitIds'].push(item);
    }
    data['roleName'] = this.roleName;
    if (Array.isArray(this.units)) {
      data['units'] = [];
      for (let item of this.units) data['units'].push(item ? item.toJSON() : (undefined as any));
    }
    data['id'] = this.id;
    data['companyId'] = this.companyId;
    data['ssoLogin'] = this.ssoLogin;
    data['subId'] = this.subId;
    data['firstName'] = this.firstName;
    data['secondName'] = this.secondName;
    data['lastName'] = this.lastName;
    data['identifierType'] = this.identifierType;
    data['identifierValue'] = this.identifierValue;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['title'] = this.title;
    data['licenceNumber'] = this.licenceNumber;
    data['specialisation'] = this.specialisation;
    data['defaultUnitId'] = this.defaultUnitId;
    data['roleId'] = this.roleId;
    data['isActive'] = this.isActive;
    data['timeStamp'] = this.timeStamp ? this.timeStamp.toISOString() : (undefined as any);
    return data;
  }
}

export interface ILoginIdetityUserDetails {
  roles?: string[] | undefined;
  claims?: { [key: string]: string } | undefined;
  login?: string | undefined;
  unitIds?: number[] | undefined;
  roleName?: string | undefined;
  units?: UnitItem[] | undefined;
  id?: number;
  companyId?: number;
  ssoLogin?: string | undefined;
  subId?: number;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: string | undefined;
  roleId?: number;
  isActive?: boolean;
  timeStamp?: Date;
}

export class LoginUserDetails implements ILoginUserDetails {
  login?: string | undefined;
  unitIds?: number[] | undefined;
  roleName?: string | undefined;
  units?: UnitItem[] | undefined;
  id?: number;
  companyId?: number;
  ssoLogin?: string | undefined;
  subId?: number;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: string | undefined;
  roleId?: number;
  isActive?: boolean;
  timeStamp?: Date;

  constructor(data?: ILoginUserDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.login = _data['login'];
      if (Array.isArray(_data['unitIds'])) {
        this.unitIds = [] as any;
        for (let item of _data['unitIds']) this.unitIds!.push(item);
      }
      this.roleName = _data['roleName'];
      if (Array.isArray(_data['units'])) {
        this.units = [] as any;
        for (let item of _data['units']) this.units!.push(UnitItem.fromJS(item));
      }
      this.id = _data['id'];
      this.companyId = _data['companyId'];
      this.ssoLogin = _data['ssoLogin'];
      this.subId = _data['subId'];
      this.firstName = _data['firstName'];
      this.secondName = _data['secondName'];
      this.lastName = _data['lastName'];
      this.identifierType = _data['identifierType'];
      this.identifierValue = _data['identifierValue'];
      this.email = _data['email'];
      this.phone = _data['phone'];
      this.title = _data['title'];
      this.licenceNumber = _data['licenceNumber'];
      this.specialisation = _data['specialisation'];
      this.defaultUnitId = _data['defaultUnitId'];
      this.roleId = _data['roleId'];
      this.isActive = _data['isActive'];
      this.timeStamp = _data['timeStamp']
        ? new Date(_data['timeStamp'].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): LoginUserDetails {
    data = typeof data === 'object' ? data : {};
    let result = new LoginUserDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['login'] = this.login;
    if (Array.isArray(this.unitIds)) {
      data['unitIds'] = [];
      for (let item of this.unitIds) data['unitIds'].push(item);
    }
    data['roleName'] = this.roleName;
    if (Array.isArray(this.units)) {
      data['units'] = [];
      for (let item of this.units) data['units'].push(item ? item.toJSON() : (undefined as any));
    }
    data['id'] = this.id;
    data['companyId'] = this.companyId;
    data['ssoLogin'] = this.ssoLogin;
    data['subId'] = this.subId;
    data['firstName'] = this.firstName;
    data['secondName'] = this.secondName;
    data['lastName'] = this.lastName;
    data['identifierType'] = this.identifierType;
    data['identifierValue'] = this.identifierValue;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['title'] = this.title;
    data['licenceNumber'] = this.licenceNumber;
    data['specialisation'] = this.specialisation;
    data['defaultUnitId'] = this.defaultUnitId;
    data['roleId'] = this.roleId;
    data['isActive'] = this.isActive;
    data['timeStamp'] = this.timeStamp ? this.timeStamp.toISOString() : (undefined as any);
    return data;
  }
}

export interface ILoginUserDetails {
  login?: string | undefined;
  unitIds?: number[] | undefined;
  roleName?: string | undefined;
  units?: UnitItem[] | undefined;
  id?: number;
  companyId?: number;
  ssoLogin?: string | undefined;
  subId?: number;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: string | undefined;
  roleId?: number;
  isActive?: boolean;
  timeStamp?: Date;
}

export class NhfAccessChangePasswordRequest implements INhfAccessChangePasswordRequest {
  id?: number;
  oldPassword?: string | undefined;
  newPassword?: string | undefined;

  constructor(data?: INhfAccessChangePasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.oldPassword = _data['oldPassword'];
      this.newPassword = _data['newPassword'];
    }
  }

  static fromJS(data: any): NhfAccessChangePasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new NhfAccessChangePasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['oldPassword'] = this.oldPassword;
    data['newPassword'] = this.newPassword;
    return data;
  }
}

export interface INhfAccessChangePasswordRequest {
  id?: number;
  oldPassword?: string | undefined;
  newPassword?: string | undefined;
}

export class NhfAccessCreateRequest implements INhfAccessCreateRequest {
  userId?: string | undefined;
  systemType?: NhfSystemType;
  nhfBranchCode?: string | undefined;
  loginType?: NhfLoginType;
  serviceProviderCode?: string | undefined;
  login?: string | undefined;
  password?: string | undefined;

  constructor(data?: INhfAccessCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.systemType = _data['systemType'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.loginType = _data['loginType'];
      this.serviceProviderCode = _data['serviceProviderCode'];
      this.login = _data['login'];
      this.password = _data['password'];
    }
  }

  static fromJS(data: any): NhfAccessCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new NhfAccessCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['systemType'] = this.systemType;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['loginType'] = this.loginType;
    data['serviceProviderCode'] = this.serviceProviderCode;
    data['login'] = this.login;
    data['password'] = this.password;
    return data;
  }
}

export interface INhfAccessCreateRequest {
  userId?: string | undefined;
  systemType?: NhfSystemType;
  nhfBranchCode?: string | undefined;
  loginType?: NhfLoginType;
  serviceProviderCode?: string | undefined;
  login?: string | undefined;
  password?: string | undefined;
}

export class NhfAccessOtpCreateRequest implements INhfAccessOtpCreateRequest {
  companyId?: number;
  systemType?: NhfSystemType;
  nhfBranchCode?: string | undefined;
  serviceProviderCode?: string | undefined;
  otpCode?: string | undefined;

  constructor(data?: INhfAccessOtpCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyId = _data['companyId'];
      this.systemType = _data['systemType'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.serviceProviderCode = _data['serviceProviderCode'];
      this.otpCode = _data['otpCode'];
    }
  }

  static fromJS(data: any): NhfAccessOtpCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new NhfAccessOtpCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['companyId'] = this.companyId;
    data['systemType'] = this.systemType;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['serviceProviderCode'] = this.serviceProviderCode;
    data['otpCode'] = this.otpCode;
    return data;
  }
}

export interface INhfAccessOtpCreateRequest {
  companyId?: number;
  systemType?: NhfSystemType;
  nhfBranchCode?: string | undefined;
  serviceProviderCode?: string | undefined;
  otpCode?: string | undefined;
}

export class NhfAccessOtpUpdateRequest implements INhfAccessOtpUpdateRequest {
  id?: number;
  otpCode?: string | undefined;

  constructor(data?: INhfAccessOtpUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.otpCode = _data['otpCode'];
    }
  }

  static fromJS(data: any): NhfAccessOtpUpdateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new NhfAccessOtpUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['otpCode'] = this.otpCode;
    return data;
  }
}

export interface INhfAccessOtpUpdateRequest {
  id?: number;
  otpCode?: string | undefined;
}

export class NhfAccessRowItem implements INhfAccessRowItem {
  position?: number;
  id?: number;
  login?: string | undefined;
  userId?: string | undefined;
  systemType?: NhfSystemType;
  nhfBranchCode?: string | undefined;
  loginType?: NhfLoginType;
  serviceProviderCode?: string | undefined;
  ssoLogin?: string | undefined;
  isGlobalAccount?: boolean;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;

  constructor(data?: INhfAccessRowItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.position = _data['position'];
      this.id = _data['id'];
      this.login = _data['login'];
      this.userId = _data['userId'];
      this.systemType = _data['systemType'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.loginType = _data['loginType'];
      this.serviceProviderCode = _data['serviceProviderCode'];
      this.ssoLogin = _data['ssoLogin'];
      this.isGlobalAccount = _data['isGlobalAccount'];
      this.email = _data['email'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
    }
  }

  static fromJS(data: any): NhfAccessRowItem {
    data = typeof data === 'object' ? data : {};
    let result = new NhfAccessRowItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['position'] = this.position;
    data['id'] = this.id;
    data['login'] = this.login;
    data['userId'] = this.userId;
    data['systemType'] = this.systemType;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['loginType'] = this.loginType;
    data['serviceProviderCode'] = this.serviceProviderCode;
    data['ssoLogin'] = this.ssoLogin;
    data['isGlobalAccount'] = this.isGlobalAccount;
    data['email'] = this.email;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    return data;
  }
}

export interface INhfAccessRowItem {
  position?: number;
  id?: number;
  login?: string | undefined;
  userId?: string | undefined;
  systemType?: NhfSystemType;
  nhfBranchCode?: string | undefined;
  loginType?: NhfLoginType;
  serviceProviderCode?: string | undefined;
  ssoLogin?: string | undefined;
  isGlobalAccount?: boolean;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
}

export class NhfAccessRowItemSearchResult implements INhfAccessRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: NhfAccessRowItem[] | undefined;

  constructor(data?: INhfAccessRowItemSearchResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPage = _data['currentPage'];
      this.total = _data['total'];
      if (Array.isArray(_data['results'])) {
        this.results = [] as any;
        for (let item of _data['results']) this.results!.push(NhfAccessRowItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): NhfAccessRowItemSearchResult {
    data = typeof data === 'object' ? data : {};
    let result = new NhfAccessRowItemSearchResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPage'] = this.currentPage;
    data['total'] = this.total;
    if (Array.isArray(this.results)) {
      data['results'] = [];
      for (let item of this.results)
        data['results'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface INhfAccessRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: NhfAccessRowItem[] | undefined;
}

export enum NhfLoginType {
  ServiceProvider = 'ServiceProvider',
  Phsician = 'Phsician',
}

export enum NhfSystemType {
  Ewus = 'Ewus',
  Kolce = 'Kolce',
}

export class P1Profile implements IP1Profile {
  id?: number;
  companyId?: number;
  subject?: string | undefined;
  wssCertThumbprint?: string | undefined;
  wssCertExpiresAt?: Date;
  tlsCertThumbprint?: string | undefined;
  tlsCertExpiresAt?: Date;

  constructor(data?: IP1Profile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.companyId = _data['companyId'];
      this.subject = _data['subject'];
      this.wssCertThumbprint = _data['wssCertThumbprint'];
      this.wssCertExpiresAt = _data['wssCertExpiresAt']
        ? new Date(_data['wssCertExpiresAt'].toString())
        : (undefined as any);
      this.tlsCertThumbprint = _data['tlsCertThumbprint'];
      this.tlsCertExpiresAt = _data['tlsCertExpiresAt']
        ? new Date(_data['tlsCertExpiresAt'].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): P1Profile {
    data = typeof data === 'object' ? data : {};
    let result = new P1Profile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['companyId'] = this.companyId;
    data['subject'] = this.subject;
    data['wssCertThumbprint'] = this.wssCertThumbprint;
    data['wssCertExpiresAt'] = this.wssCertExpiresAt
      ? this.wssCertExpiresAt.toISOString()
      : (undefined as any);
    data['tlsCertThumbprint'] = this.tlsCertThumbprint;
    data['tlsCertExpiresAt'] = this.tlsCertExpiresAt
      ? this.tlsCertExpiresAt.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IP1Profile {
  id?: number;
  companyId?: number;
  subject?: string | undefined;
  wssCertThumbprint?: string | undefined;
  wssCertExpiresAt?: Date;
  tlsCertThumbprint?: string | undefined;
  tlsCertExpiresAt?: Date;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: string | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: string | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class SettlementProfile implements ISettlementProfile {
  serviceProviderCode?: string | undefined;
  nhfBranchCode?: string | undefined;
  companyName?: string | undefined;
  branchName?: string | undefined;
  settlementWsTransportProfile?: SettlementWsTransportProfile;

  constructor(data?: ISettlementProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceProviderCode = _data['serviceProviderCode'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.companyName = _data['companyName'];
      this.branchName = _data['branchName'];
      this.settlementWsTransportProfile = _data['settlementWsTransportProfile']
        ? SettlementWsTransportProfile.fromJS(_data['settlementWsTransportProfile'])
        : (undefined as any);
    }
  }

  static fromJS(data: any): SettlementProfile {
    data = typeof data === 'object' ? data : {};
    let result = new SettlementProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serviceProviderCode'] = this.serviceProviderCode;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['companyName'] = this.companyName;
    data['branchName'] = this.branchName;
    data['settlementWsTransportProfile'] = this.settlementWsTransportProfile
      ? this.settlementWsTransportProfile.toJSON()
      : (undefined as any);
    return data;
  }
}

export interface ISettlementProfile {
  serviceProviderCode?: string | undefined;
  nhfBranchCode?: string | undefined;
  companyName?: string | undefined;
  branchName?: string | undefined;
  settlementWsTransportProfile?: SettlementWsTransportProfile;
}

export class SettlementWsTransportProfile implements ISettlementWsTransportProfile {
  authUrl?: string | undefined;
  brokerUrl?: string | undefined;
  branchCode?: string | undefined;
  user?: string | undefined;
  providerCode?: string | undefined;
  roleType?: string | undefined;

  constructor(data?: ISettlementWsTransportProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authUrl = _data['authUrl'];
      this.brokerUrl = _data['brokerUrl'];
      this.branchCode = _data['branchCode'];
      this.user = _data['user'];
      this.providerCode = _data['providerCode'];
      this.roleType = _data['roleType'];
    }
  }

  static fromJS(data: any): SettlementWsTransportProfile {
    data = typeof data === 'object' ? data : {};
    let result = new SettlementWsTransportProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['authUrl'] = this.authUrl;
    data['brokerUrl'] = this.brokerUrl;
    data['branchCode'] = this.branchCode;
    data['user'] = this.user;
    data['providerCode'] = this.providerCode;
    data['roleType'] = this.roleType;
    return data;
  }
}

export interface ISettlementWsTransportProfile {
  authUrl?: string | undefined;
  brokerUrl?: string | undefined;
  branchCode?: string | undefined;
  user?: string | undefined;
  providerCode?: string | undefined;
  roleType?: string | undefined;
}

export class UnitItem implements IUnitItem {
  id?: number;
  name?: string | undefined;

  constructor(data?: IUnitItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): UnitItem {
    data = typeof data === 'object' ? data : {};
    let result = new UnitItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IUnitItem {
  id?: number;
  name?: string | undefined;
}

export class UserCreateRequest implements IUserCreateRequest {
  login?: string | undefined;
  password?: string | undefined;
  internalRoles?: string[] | undefined;
  tenants?: string[] | undefined;
  roleId?: number;
  roleName?: string | undefined;
  unitIds?: number[] | undefined;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: number;
  modules?: string[] | undefined;

  constructor(data?: IUserCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.login = _data['login'];
      this.password = _data['password'];
      if (Array.isArray(_data['internalRoles'])) {
        this.internalRoles = [] as any;
        for (let item of _data['internalRoles']) this.internalRoles!.push(item);
      }
      if (Array.isArray(_data['tenants'])) {
        this.tenants = [] as any;
        for (let item of _data['tenants']) this.tenants!.push(item);
      }
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
      if (Array.isArray(_data['unitIds'])) {
        this.unitIds = [] as any;
        for (let item of _data['unitIds']) this.unitIds!.push(item);
      }
      this.firstName = _data['firstName'];
      this.secondName = _data['secondName'];
      this.lastName = _data['lastName'];
      this.identifierType = _data['identifierType'];
      this.identifierValue = _data['identifierValue'];
      this.email = _data['email'];
      this.phone = _data['phone'];
      this.title = _data['title'];
      this.licenceNumber = _data['licenceNumber'];
      this.specialisation = _data['specialisation'];
      this.defaultUnitId = _data['defaultUnitId'];
      if (Array.isArray(_data['modules'])) {
        this.modules = [] as any;
        for (let item of _data['modules']) this.modules!.push(item);
      }
    }
  }

  static fromJS(data: any): UserCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['login'] = this.login;
    data['password'] = this.password;
    if (Array.isArray(this.internalRoles)) {
      data['internalRoles'] = [];
      for (let item of this.internalRoles) data['internalRoles'].push(item);
    }
    if (Array.isArray(this.tenants)) {
      data['tenants'] = [];
      for (let item of this.tenants) data['tenants'].push(item);
    }
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    if (Array.isArray(this.unitIds)) {
      data['unitIds'] = [];
      for (let item of this.unitIds) data['unitIds'].push(item);
    }
    data['firstName'] = this.firstName;
    data['secondName'] = this.secondName;
    data['lastName'] = this.lastName;
    data['identifierType'] = this.identifierType;
    data['identifierValue'] = this.identifierValue;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['title'] = this.title;
    data['licenceNumber'] = this.licenceNumber;
    data['specialisation'] = this.specialisation;
    data['defaultUnitId'] = this.defaultUnitId;
    if (Array.isArray(this.modules)) {
      data['modules'] = [];
      for (let item of this.modules) data['modules'].push(item);
    }
    return data;
  }
}

export interface IUserCreateRequest {
  login?: string | undefined;
  password?: string | undefined;
  internalRoles?: string[] | undefined;
  tenants?: string[] | undefined;
  roleId?: number;
  roleName?: string | undefined;
  unitIds?: number[] | undefined;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: number;
  modules?: string[] | undefined;
}

export class UserHeaderRowItem implements IUserHeaderRowItem {
  ssoLogin?: string | undefined;
  position?: number;
  id?: number;
  subId?: number;
  login?: string | undefined;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: string | undefined;
  roleId?: number;
  timeStamp?: Date;
  unitName?: string | undefined;
  roleName?: string | undefined;
  defaultUnitName?: string | undefined;
  isActive?: boolean;

  constructor(data?: IUserHeaderRowItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ssoLogin = _data['ssoLogin'];
      this.position = _data['position'];
      this.id = _data['id'];
      this.subId = _data['subId'];
      this.login = _data['login'];
      this.firstName = _data['firstName'];
      this.secondName = _data['secondName'];
      this.lastName = _data['lastName'];
      this.identifierType = _data['identifierType'];
      this.identifierValue = _data['identifierValue'];
      this.email = _data['email'];
      this.phone = _data['phone'];
      this.title = _data['title'];
      this.licenceNumber = _data['licenceNumber'];
      this.specialisation = _data['specialisation'];
      this.defaultUnitId = _data['defaultUnitId'];
      this.roleId = _data['roleId'];
      this.timeStamp = _data['timeStamp']
        ? new Date(_data['timeStamp'].toString())
        : (undefined as any);
      this.unitName = _data['unitName'];
      this.roleName = _data['roleName'];
      this.defaultUnitName = _data['defaultUnitName'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): UserHeaderRowItem {
    data = typeof data === 'object' ? data : {};
    let result = new UserHeaderRowItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ssoLogin'] = this.ssoLogin;
    data['position'] = this.position;
    data['id'] = this.id;
    data['subId'] = this.subId;
    data['login'] = this.login;
    data['firstName'] = this.firstName;
    data['secondName'] = this.secondName;
    data['lastName'] = this.lastName;
    data['identifierType'] = this.identifierType;
    data['identifierValue'] = this.identifierValue;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['title'] = this.title;
    data['licenceNumber'] = this.licenceNumber;
    data['specialisation'] = this.specialisation;
    data['defaultUnitId'] = this.defaultUnitId;
    data['roleId'] = this.roleId;
    data['timeStamp'] = this.timeStamp ? this.timeStamp.toISOString() : (undefined as any);
    data['unitName'] = this.unitName;
    data['roleName'] = this.roleName;
    data['defaultUnitName'] = this.defaultUnitName;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IUserHeaderRowItem {
  ssoLogin?: string | undefined;
  position?: number;
  id?: number;
  subId?: number;
  login?: string | undefined;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: string | undefined;
  roleId?: number;
  timeStamp?: Date;
  unitName?: string | undefined;
  roleName?: string | undefined;
  defaultUnitName?: string | undefined;
  isActive?: boolean;
}

export class UserHeaderRowItemSearchResult implements IUserHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: UserHeaderRowItem[] | undefined;

  constructor(data?: IUserHeaderRowItemSearchResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPage = _data['currentPage'];
      this.total = _data['total'];
      if (Array.isArray(_data['results'])) {
        this.results = [] as any;
        for (let item of _data['results']) this.results!.push(UserHeaderRowItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserHeaderRowItemSearchResult {
    data = typeof data === 'object' ? data : {};
    let result = new UserHeaderRowItemSearchResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPage'] = this.currentPage;
    data['total'] = this.total;
    if (Array.isArray(this.results)) {
      data['results'] = [];
      for (let item of this.results)
        data['results'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IUserHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: UserHeaderRowItem[] | undefined;
}

export class UserUpdateRequest implements IUserUpdateRequest {
  id?: number;
  internalRoles?: string[] | undefined;
  tenants?: string[] | undefined;
  roleId?: number;
  roleName?: string | undefined;
  unitIds?: number[] | undefined;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: number;
  modules?: string[] | undefined;

  constructor(data?: IUserUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      if (Array.isArray(_data['internalRoles'])) {
        this.internalRoles = [] as any;
        for (let item of _data['internalRoles']) this.internalRoles!.push(item);
      }
      if (Array.isArray(_data['tenants'])) {
        this.tenants = [] as any;
        for (let item of _data['tenants']) this.tenants!.push(item);
      }
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
      if (Array.isArray(_data['unitIds'])) {
        this.unitIds = [] as any;
        for (let item of _data['unitIds']) this.unitIds!.push(item);
      }
      this.firstName = _data['firstName'];
      this.secondName = _data['secondName'];
      this.lastName = _data['lastName'];
      this.identifierType = _data['identifierType'];
      this.identifierValue = _data['identifierValue'];
      this.email = _data['email'];
      this.phone = _data['phone'];
      this.title = _data['title'];
      this.licenceNumber = _data['licenceNumber'];
      this.specialisation = _data['specialisation'];
      this.defaultUnitId = _data['defaultUnitId'];
      if (Array.isArray(_data['modules'])) {
        this.modules = [] as any;
        for (let item of _data['modules']) this.modules!.push(item);
      }
    }
  }

  static fromJS(data: any): UserUpdateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    if (Array.isArray(this.internalRoles)) {
      data['internalRoles'] = [];
      for (let item of this.internalRoles) data['internalRoles'].push(item);
    }
    if (Array.isArray(this.tenants)) {
      data['tenants'] = [];
      for (let item of this.tenants) data['tenants'].push(item);
    }
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    if (Array.isArray(this.unitIds)) {
      data['unitIds'] = [];
      for (let item of this.unitIds) data['unitIds'].push(item);
    }
    data['firstName'] = this.firstName;
    data['secondName'] = this.secondName;
    data['lastName'] = this.lastName;
    data['identifierType'] = this.identifierType;
    data['identifierValue'] = this.identifierValue;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['title'] = this.title;
    data['licenceNumber'] = this.licenceNumber;
    data['specialisation'] = this.specialisation;
    data['defaultUnitId'] = this.defaultUnitId;
    if (Array.isArray(this.modules)) {
      data['modules'] = [];
      for (let item of this.modules) data['modules'].push(item);
    }
    return data;
  }
}

export interface IUserUpdateRequest {
  id?: number;
  internalRoles?: string[] | undefined;
  tenants?: string[] | undefined;
  roleId?: number;
  roleName?: string | undefined;
  unitIds?: number[] | undefined;
  firstName?: string | undefined;
  secondName?: string | undefined;
  lastName?: string | undefined;
  identifierType?: IdentityTypes;
  identifierValue?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  title?: string | undefined;
  licenceNumber?: string | undefined;
  specialisation?: string | undefined;
  defaultUnitId?: number;
  modules?: string[] | undefined;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
